import { useEffect, useState } from "react";

const storageKey = "two-carats-selected-unit";
const eventName = "two-carats-unit-changed";

export function useSelectedUnitId(availableUnitIds: string[]) {
  const [stored, setStored] = useState(() => localStorage.getItem(storageKey) ?? "");
  const availableKey = availableUnitIds.join("\0");
  useEffect(() => {
    const update = () => setStored(localStorage.getItem(storageKey) ?? "");
    window.addEventListener(eventName, update);
    return () => window.removeEventListener(eventName, update);
  }, []);
  useEffect(() => {
    if (!availableUnitIds.length || availableUnitIds.includes(stored)) return;
    const fallback = availableUnitIds[0];
    localStorage.setItem(storageKey, fallback);
    setStored(fallback);
    window.dispatchEvent(new Event(eventName));
  }, [availableKey, stored]);
  const selected = availableUnitIds.includes(stored) ? stored : availableUnitIds[0] ?? "";
  const select = (unitId: string) => {
    localStorage.setItem(storageKey, unitId);
    setStored(unitId);
    window.dispatchEvent(new Event(eventName));
  };
  return [selected, select] as const;
}

export function useCurrentUnitId() {
  const [selected, setSelected] = useState(() => localStorage.getItem(storageKey) ?? "");
  useEffect(() => {
    const update = () => setSelected(localStorage.getItem(storageKey) ?? "");
    window.addEventListener(eventName, update);
    return () => window.removeEventListener(eventName, update);
  }, []);
  return selected;
}

export function withCurrentUnit(url: string, unitId: string) {
  if (!unitId) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}unitId=${encodeURIComponent(unitId)}`;
}
